export default __webpack_public_path__ + "static/media/logo-com-service.aa759090.svg";